/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import React, {memo, ReactNode} from "react";
import {createUseStyles} from "react-jss";
import UI from "./UI";

const useStyles = createUseStyles({
    root: {
        margin: "auto",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        [UI.media.only("sm")]: {
            maxWidth: 540
        },
        [UI.media.only("md")]: {
            maxWidth: 720
        },
        [UI.media.only("lg")]: {
            maxWidth: 960
        },
        [UI.media.only("xl")]: {
            maxWidth: 1140
        }
    }
});

interface ContainerProps {
    children: ReactNode;
}

export function Container(props: ContainerProps) {
    const classes = useStyles();
    return <div className={classes.root}>{props.children}</div>;
}

export default memo(Container);
